import React from 'react';
import PropTypes from 'prop-types';
import CustomButton from './CustomButton';
import styles from '../css/app.css';

const CustomButtons = ({
  links,
  buttonColor,
  textColor,
}) => {
  const children = links.custom_links.map(
    ({
      id,
      order,
      text,
      url,
    }) => (
      <CustomButton
        url={url}
        order={order}
        key={id}
        text={text}
        buttonColor={buttonColor}
        textColor={textColor}
      />
    )
  );

  const orderedChildren = Object.values(children).sort((a, b) => (a.props.order - b.props.order));
  return (
    <div className={styles.custom_buttons}>
      {orderedChildren}
    </div>
  );
};

CustomButtons.propTypes = {
  links: PropTypes.shape({
    custom_links_color: PropTypes.string,
    custom_links_contrast_color: PropTypes.string,
    custom_links: PropTypes.array,
  }).isRequired,
  buttonColor: PropTypes.string.isRequired,
  textColor: PropTypes.string.isRequired,
};

export default CustomButtons;



/** WEBPACK FOOTER **
 ** ./app/webroot/js/instagramBioGrid/components/CustomButtons.jsx
 **/